import React, { Component } from 'react'
import { connect as reduxConnect } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import ReactTable from 'react-table'

import { planTypeForValue } from '_utils/planType'
import { subscriptionTypeConversion } from '_utils/subscriptionType'
import { storeTypeForValue } from '_utils/storeType'
import { logEntryTypeForValue } from '_utils/logEntryType'
import { BACKEND_URL } from '_config/environment'

import styles from '../styles.css'
momentDurationFormatSetup(moment)

const mapStateToProps = ({ user }) => ({
  user,
})

const mapDispatchToProps = {}

const taskTypeStatsColumns = [
  {
    Header: 'Now',
    accessor: 'Now',
  },
  {
    Header: 'Mindful Break',
    accessor: 'Mindful Break',
  },
  {
    Header: 'Today Item',
    accessor: 'Today Item',
  },
  {
    Header: 'Capture Item',
    accessor: 'Capture Item',
  },
  {
    Header: 'Manual Item',
    accessor: 'Manual Item',
  },
  {
    Header: 'Total',
    accessor: 'Total',
  },
]

const logsWithinStatsColumns = [
  {
    Header: 'Today',
    accessor: 'Today',
  },
  {
    Header: 'Week',
    accessor: 'Week',
  },
  {
    Header: 'Two Weeks',
    accessor: 'Two Weeks',
  },

  {
    Header: 'Three Weeks',
    accessor: 'Three Weeks',
  },
  {
    Header: 'Month',
    accessor: 'Month',
  },
  {
    Header: 'Two Months',
    accessor: 'Two Months',
  },
]

class UserDetail extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    user: ImmutableProptypes.map,
    onEditClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
  }
  constructor(props) {
    super(props)

    this.state = {
      user: {},
      log: [],
      subscription: {},
      logsWithinStats: {},
      taskTypeStats: {},
    }
  }

  componentDidMount() {
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
  }

  getState = props => {
    const { id } = props

    fetch(`${BACKEND_URL || 'http://localhost:3000'}/admin/getUserDetails/${id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.props.user.get('token')}`,
      },
    })
      .then(res => res.json())
      .then(userData => {
        const { user, log, subscription } = userData

        const taskTypeStats = log.reduce(
          (acc, curr) => {
            acc[logEntryTypeForValue(curr.type)] += 1
            acc.Total += 1
            return acc
          },
          {
            Now: 0,
            'Mindful Break': 0,
            'Today Item': 0,
            'Capture Item': 0,
            'Manual Item': 0,
            Total: 0,
          }
        )

        const logsWithinStats = log.reduce(
          (acc, curr) => {
            const today = moment().startOf('day')
            const weekAgo = moment()
              .subtract(1, 'weeks')
              .startOf('day')
            const twoWeeksAgo = moment()
              .subtract(2, 'weeks')
              .startOf('day')
            const threeWeeksAgo = moment()
              .subtract(3, 'weeks')
              .startOf('day')
            const monthAgo = moment()
              .subtract(1, 'months')
              .startOf('day')
            const twoMonthsAgo = moment()
              .subtract(2, 'months')
              .startOf('day')

            const currUpdatedAt = moment(curr.updatedAt)
            if (currUpdatedAt.isAfter(today)) acc.Today += 1
            if (currUpdatedAt.isAfter(weekAgo)) acc.Week += 1
            if (currUpdatedAt.isAfter(twoWeeksAgo)) acc['Two Weeks'] += 1
            if (currUpdatedAt.isAfter(threeWeeksAgo)) acc['Three Weeks'] += 1
            if (currUpdatedAt.isAfter(monthAgo)) acc.Month += 1
            if (currUpdatedAt.isAfter(twoMonthsAgo)) acc['Two Months'] += 1
            return acc
          },
          {
            Today: 0,
            Week: 0,
            'Two Weeks': 0,
            'Three Weeks': 0,
            Month: 0,
            'Two Months': 0,
          }
        )

        this.setState({
          user,
          log,
          taskTypeStats,
          logsWithinStats,
          subscription: subscription || null,
        })
      })
      .catch(err => console.error(err))
  }

  onClickEdit = () => {
    this.props.onEditClick(this.state.user)
  }

  render() {
    const { user, subscription, taskTypeStats, logsWithinStats } = this.state

    return (
      <div className={classnames(styles.main)}>
        {/* Name + Important info */}
        <div className={classnames(styles.Grid)}>
          <div className={classnames(styles.name)}>
            {user.name ? `${user.name.first} ${user.name.last}` : ''}
          </div>
          <div className={classnames(styles.email, styles['u-sizeFill'])}>{user.email}</div>
          <div className={classnames(styles.name)}>
            <button onClick={this.onClickEdit}>
              <i className={classnames('fa fa-pencil')} />
            </button>
          </div>
        </div>
        <div className={classnames(styles.Grid, styles.section)}>
          <i
            style={{ color: 'rgb(255,255,255)', fontSize: 20 }}
            className={classnames('fa fa-user')}
          />
          <div
            style={{ color: 'rgba(255,255,255)', fontSize: 20, paddingRight: 7, paddingLeft: 7 }}
          >
            Created On
          </div>
          <div style={{ color: '#D4E4BC', fontSize: 20, paddingRight: 7 }}>
            {moment(user.createdAt).format('YYYY/MM/DD, h:mm:ss a')}
          </div>
        </div>
        <div className={styles.line} />
        {/* Subscription Details */}
        <div className={classnames(styles.Grid, styles.section)}>
          <div className={classnames(styles.sectionTitle)}>Subscription Details</div>
          <div className={classnames(styles.Grid, styles.sectionItem)}>
            <div style={{ width: 25 }}>
              <i
                style={{ color: 'rgb(255,255,255)', fontSize: 20 }}
                className={classnames('fa fa-exclamation-triangle')}
              />
            </div>
            <div
              style={{ color: 'rgba(255,255,255)', fontSize: 20, paddingRight: 7, paddingLeft: 7 }}
            >
              Trial Expires
            </div>
            <div style={{ color: '#A3C3D9', fontSize: 20 }}>
              {moment(user.trialExpiresAt).format('MM-DD-YYYY')}
            </div>
          </div>

          <div className={classnames(styles.Grid, styles.sectionItem)}>
            <div style={{ width: 25 }}>
              <i
                style={{ color: 'rgb(255,255,255)', fontSize: 20 }}
                className={classnames('fa fa-refresh')}
              />
            </div>
            <div
              style={{ color: 'rgba(255,255,255)', fontSize: 20, paddingRight: 7, paddingLeft: 7 }}
            >
              Subscribed To
            </div>
            <div style={{ color: '#D4E4BC', fontSize: 20, paddingRight: 7 }}>
              {`${planTypeForValue(user.planType)}`}
            </div>
            <div style={{ color: '#A3C3D9', fontSize: 20 }}>
              {subscription && `${subscriptionTypeConversion(subscription.subscriptionType)}`}
            </div>
          </div>
          {subscription &&
            subscription.subscriptionData && (
              <div>
                <div className={classnames(styles.Grid, styles.sectionItem)}>
                  <div style={{ width: 25 }}>
                    <i
                      style={{ color: 'rgb(255,255,255)', fontSize: 20 }}
                      className={classnames('fa fa-building')}
                    />
                  </div>
                  <div
                    style={{
                      color: 'rgba(255,255,255)',
                      fontSize: 20,
                      paddingRight: 7,
                      paddingLeft: 7,
                    }}
                  >
                    Managed By
                  </div>
                  <div style={{ color: '#D4E4BC', fontSize: 20, paddingRight: 7 }}>
                    {`${storeTypeForValue(subscription.storeType)}`}
                  </div>
                </div>

                <div className={classnames(styles.Grid, styles.sectionItem)}>
                  <div style={{ width: 25 }}>
                    <i
                      style={{ color: 'rgb(255,255,255)', fontSize: 20 }}
                      className={classnames('fa fa-credit-card')}
                    />
                  </div>

                  <div
                    style={{
                      color: 'rgba(255,255,255)',
                      fontSize: 20,
                      paddingRight: 7,
                      paddingLeft: 7,
                    }}
                  >
                    Paid Until
                  </div>
                  <div style={{ color: '#D4E4BC', fontSize: 20, paddingRight: 7 }}>
                    {moment(subscription.createdAt)
                      .add(1, 'month')
                      .format('MM/DD/YYYY') ||
                      moment(subscription.subscriptionData.subscription.billing_cycle_anchor * 1000)
                        .add(1, 'month')
                        .format('MM/DD/YYYY')}
                  </div>
                </div>
              </div>
            )}
        </div>
        <div className={styles.line} />
        {/* Task Type Stats */}
        <div className={classnames(styles.Grid, styles.section)}>
          <div className={classnames(styles.sectionTitle)}>Task Type Stats</div>
          <div style={{ width: '100%' }}>
            <ReactTable
              data={[taskTypeStats]}
              columns={taskTypeStatsColumns}
              showPagination={false}
              defaultPageSize={1}
              style={{ background: 'white', fontSize: 14 }}
            />
          </div>
        </div>
        {/* Logs Within */}
        <div className={classnames(styles.Grid, styles.section)}>
          <div className={classnames(styles.sectionTitle)}>Logs Within</div>
          <div style={{ width: '100%' }}>
            <ReactTable
              data={[logsWithinStats]}
              columns={logsWithinStatsColumns}
              showPagination={false}
              defaultPageSize={1}
              style={{ background: 'white', fontSize: 14 }}
            />
          </div>
        </div>
      </div>
    )
  }
}
export default reduxConnect(mapStateToProps, mapDispatchToProps)(UserDetail)



// WEBPACK FOOTER //
// ./src/views/admin/components/UserDetail.js